import { Switch, styled } from "@mui/material";

const IOSSwitch = styled(Switch)(({ theme }) => ({
  width: 37,
  height: 22,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 1,
    transitionDuration: "300ms",
    color: theme.palette.gray60.main,
    "&.Mui-checked": {
      transform: "translateX(15px)",
      color: theme.palette.common.white,
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: "none",
      },
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.gray40.main,
      color: theme.palette.gray40.main,
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.gray40.main}`,
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled": {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.gray40.main,
    "& + .MuiSwitch-track": {
      backgroundColor: theme.palette.gray40.main,
      border: "none",
      opacity: 1,
    },
  },
  "& .MuiSwitch-thumb": {
    width: 20,
    height: 20,
    boxShadow: "none",
  },
  "& .MuiSwitch-track": {
    borderRadius: 12,
    border: `1px solid ${theme.palette.gray60.main}`,
    boxSizing: "border-box",
    backgroundColor: theme.palette.white.main,
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
}));

export default IOSSwitch;
